<template>
    <div id="app">
        <ejs-tab id="element" ref='userTabs'>
            <e-tabitems>
                <e-tabitem :header='headerText0' :content='marketSummaryFuture'></e-tabitem>
                <e-tabitem :header='headerText1' :content='marketSummaryExpired'></e-tabitem>
                <e-tabitem :header='headerText2' :content='spot'></e-tabitem>
                <e-tabitem :header='headerText3' :content='latestSettlement'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import LatestSettlement from '@/views/markets/LatestSettlementTab.vue';
    import MarketSummaryFuture from '@/views/markets/marketSummaryFuture/MarketSummaryFuture.vue';
    import SpotTab from '@/views/markets/spotTab/SpotPricingTab.vue';
    import MarketSummaryExpired from '@/views/markets/marketSummaryHistory/MarketHistory.vue';
    import { DatePickerComponent, CalendarComponent, DatePickerPlugin, CalendarPlugin } from '@syncfusion/ej2-vue-calendars';

    Vue.use(TabPlugin);
    Vue.use(TabPlugin);
    Vue.component(DatePickerPlugin.name, DatePickerComponent);
    Vue.component(CalendarPlugin.name, CalendarComponent);

    export default {
        name: 'app',
        data: function () {
            return {
                headerText0: { text: 'Futures' },
                headerText1: { text: 'Expired' },
                headerText2: { text: 'Spot' },
                headerText3: { text: 'Latest Settlement' },
                propsData: null,
                marketSummaryFuture: function () {
                    return {
                        template: {
                            extends: MarketSummaryFuture
                        }
                    }
                },
                marketSummaryExpired: function () {
                    return {
                        template: {
                            extends: MarketSummaryExpired
                        }
                    }
                }, 
                spot: function () {
                    return {
                        template: {
                            extends: SpotTab
                        }
                    }
                }, 
                latestSettlement: function () {
                    return {
                        template: {
                            extends: LatestSettlement
                        }
                    }
                },
            }
        },
        mounted: function () {
            if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.View"]) {
                this.$refs.userTabs.hideTab(0);
                this.$refs.userTabs.hideTab(1);
            }
            if (!this.$store.state.permissions["Permissions.SpotPricing.View"]) {
                this.$refs.userTabs.hideTab(2);
            }

            if (!this.$store.state.permissions["Permissions.LatestSettlement.View"]) {
                this.$refs.userTabs.hideTab(3);
            }

        },
    }
</script>

<style scoped>
</style>